interface Props {
  stroke?: string;
  width?: string;
  height?: string;
}
const DebtIcon = ({ height, stroke, width }: Props) => {
  return (
    <svg
      width={width || "70px"}
      height={height || "55px"}
      viewBox="0 0 23 23"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_267_27895"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="21"
        height="16"
      >
        <path
          d="M22.1672 1.39748L20.0256 15.4967L17.8935 12.6411H14.8595L8.07765 10.1425H2.36658L2 0.683594L22.1672 1.39748Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_267_27895)">
        <path
          d="M16.5576 4.03181V12.9403C16.5576 13.2144 16.4659 13.4542 16.2823 13.6598C16.0987 13.8654 15.8846 13.9682 15.6398 13.9682H5.23766C4.9929 13.9682 4.77874 13.8654 4.59518 13.6598C4.41161 13.4542 4.31982 13.2144 4.31982 12.9403V4.03181C4.31982 3.7577 4.41161 3.51786 4.59518 3.31228C4.77874 3.1067 4.9929 3.00391 5.23766 3.00391H15.6398C15.8846 3.00391 16.0987 3.1067 16.2823 3.31228C16.4659 3.51786 16.5576 3.7577 16.5576 4.03181ZM5.23766 5.89916H15.6398V4.03181H5.23766V5.89916ZM5.23766 8.10915V12.9403H15.6398V8.10915H5.23766ZM5.23766 12.9403V4.03181V12.9403Z"
          fill="currentColor"
          stroke={stroke || "currentColor"}
          strokeWidth="0.4"
        />
      </g>
      <path
        d="M11.909 20.5631L17.4038 18.6658C17.3162 18.5377 17.2068 18.3895 17.0754 18.2214C16.9441 18.0533 16.7762 17.9692 16.5719 17.9692H11.3617C11.3179 17.9692 11.172 17.9572 10.9239 17.9332C10.6758 17.9092 10.4423 17.8412 10.2234 17.7291L8.8442 17.2487C8.62528 17.1847 8.46839 17.0406 8.37353 16.8164C8.27867 16.5922 8.26772 16.3601 8.34069 16.1199C8.39907 15.8797 8.53042 15.7076 8.73474 15.6035C8.93906 15.4994 9.15068 15.4874 9.3696 15.5675L11.2961 16.288C11.2669 16.288 11.3544 16.276 11.5588 16.252C11.7631 16.228 12.1206 16.216 12.6314 16.216H12.8504C12.8504 16.0238 12.8175 15.8477 12.7518 15.6876C12.6862 15.5275 12.5731 15.4074 12.4125 15.3273L6.98341 13.0697H5.29776V18.4736L11.909 20.5631ZM11.5588 22.2444L5.29776 20.2989C5.28317 20.7633 5.09709 21.1195 4.73953 21.3677C4.38196 21.6159 4.03535 21.74 3.69968 21.74H1.59809C1.14566 21.74 0.766205 21.5719 0.459723 21.2356C0.153241 20.8994 0 20.4831 0 19.9867V13.0697C0 12.5733 0.153241 12.157 0.459723 11.8208C0.766205 11.4845 1.14566 11.3164 1.59809 11.3164H6.98341C7.07098 11.3164 7.1622 11.3244 7.25706 11.3404C7.35192 11.3564 7.45043 11.3885 7.55259 11.4365L12.9379 13.6701C13.4195 13.8623 13.799 14.1385 14.0763 14.4987C14.3536 14.859 14.4922 15.4314 14.4922 16.216H16.7471C17.4476 16.216 18.035 16.4842 18.5093 17.0206C18.9836 17.5569 19.2208 18.2575 19.2208 19.1221C19.2208 19.3783 19.1624 19.5984 19.0457 19.7826C18.9289 19.9667 18.7757 20.0908 18.586 20.1548L12.4563 22.2444C12.2958 22.2924 12.1425 22.3164 11.9966 22.3164C11.8506 22.3164 11.7047 22.2924 11.5588 22.2444ZM1.61998 19.9867H3.67779V13.0457H1.61998V19.9867Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DebtIcon;
